import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import {
  defaultMetaObj,
  initialDashboardTaskStatsState,
} from "store/constants";
import { getPaginatedUrlWithSearchParams } from "store/helper";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";

const { dashboardTaskStatsEndPoint } = endPoints;

export const fetchAllTaskStats = createAsyncThunk(
  "taskStats/fetchAllTaskStats",
  async (
    { page, searchParamsObj = {} }: { page: number; searchParamsObj?: {} },
    { rejectWithValue }
  ) => {
    const paginatedUrl = getPaginatedUrlWithSearchParams({
      pageNumber: page,
      endpoint: dashboardTaskStatsEndPoint,
      searchParams: {
        ...searchParamsObj,
      },
    });

    try {
      const response: AxiosResponse = await crudService.getAll(paginatedUrl);

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const dashboardTaskSlice = createSlice({
  name: "taskStats",
  initialState: initialDashboardTaskStatsState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all dashboard task stats
    builder
      .addCase(fetchAllTaskStats.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchAllTaskStats.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.taskStats = action.payload?.objects[0] as any[];
          state.meta = action.payload?.meta;
        }
      )
      .addCase(
        fetchAllTaskStats.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
          state.meta = defaultMetaObj;
        }
      );
  },
});

export const dashboardTaskStatsReducer = dashboardTaskSlice.reducer;
